 <template>
  <div>
    <el-date-picker
      v-model="val"
      type="date"
      :placeholder="placeholder"
      :picker-options="pickerOptions0"
      value-format="yyyy-MM-dd"
      :disabled="disabled"
      @change="$event => $emit('input',$event)"
    >
    </el-date-picker>
  </div>
</template>
 
 <script>
export default {
  props:{
    value: {
      default: '',
    } ,
    disabled: {
      default: false,
    },
    placeholder: {
        default: '选择日期'
    }
  },
  data() {
    return {
      val: this.value,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  watch: {
    value(val){
        this.val = val
    }
  }
};
</script>
 
 <style>
</style>